const RISK_CALCULATING_MS = 24 * 60 * 60 * 1000;

interface RiskSubject {
    risk_score?: number | null;
    profile_complete?: boolean;
    created_at?: string | null;
}

export type RiskState = 'score' | 'calculating' | 'pending';

// One answer for the roster cell and the drawer header, so the two can never
// disagree about an employee. A score always wins: "Calculating" is only what
// stands where a score will be. And it is only promised when scoring can
// actually run: the API stops scoring (and withholds any frozen row) the moment
// a profile is incomplete, so a new but incomplete employee is waiting on the
// profile, not on us.
export function riskState(emp: RiskSubject): RiskState {
    if (typeof emp.risk_score === 'number') return 'score';
    if (emp.profile_complete === false) return 'pending';
    const createdAt = emp.created_at ? new Date(emp.created_at).getTime() : NaN;
    return Number.isFinite(createdAt) && (Date.now() - createdAt) < RISK_CALCULATING_MS ? 'calculating' : 'pending';
}

export const riskPendingLabel = (emp: RiskSubject): string => (riskState(emp) === 'calculating' ? 'Calculating' : 'Pending');

export const riskPendingTooltip = (emp: RiskSubject): string =>
    riskState(emp) === 'calculating' ? 'Calculating, check back in 24 hours' : 'Pending profile completion';
